import React, { Component } from "react";
import { IntroPage } from "app/components/IntroPage";


import './HoneypotSetHomeComponent.scss';

class HoneypotSetHome extends Component{
    render() {		
        return (
            <IntroPage headerText="Honeypot Sets">                
                <b>Here you can</b>
                <ul className="introHomeItems">
					<li>Create new Honeypot sets</li>
					<li>Add questions to existing sets</li>
					<li>Search for existing Honeypot sets</li>
					<li>Review and manage existing Honeypot sets</li>
                </ul>
            </IntroPage>
        )
    }
}

export default HoneypotSetHome;